import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wcup-ranking-bootstrap',
  templateUrl: './wcup-ranking-bootstrap.component.html',
  styleUrls: ['./wcup-ranking-bootstrap.component.scss']
})
export class WCupRankingBootstrapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
